import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Card, Button, Typography, Rate, Tag, Space } from 'antd';
import {
  ArrowRightOutlined, CheckCircleOutlined, StarOutlined, PhoneOutlined,
  RocketOutlined, HomeOutlined, CarOutlined, SafetyOutlined, SunOutlined,
  EnvironmentOutlined, BankOutlined, FileTextOutlined,
  TeamOutlined, CompassOutlined, CoffeeOutlined, SmileOutlined,
  HeartOutlined, TrophyOutlined, CustomerServiceOutlined,
  SafetyCertificateOutlined, CrownOutlined,
  WhatsAppOutlined, AppstoreOutlined, BulbOutlined,
} from '@ant-design/icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/free-mode';
import api from '../api/axios';

const { Title, Text, Paragraph } = Typography;

const iconMap = {
  RocketOutlined: <RocketOutlined />, HomeOutlined: <HomeOutlined />,
  BankOutlined: <BankOutlined />, FileTextOutlined: <FileTextOutlined />,
  TeamOutlined: <TeamOutlined />, CarOutlined: <CarOutlined />,
  SunOutlined: <SunOutlined />, EnvironmentOutlined: <EnvironmentOutlined />,
  CoffeeOutlined: <CoffeeOutlined />, CompassOutlined: <CompassOutlined />,
  SmileOutlined: <SmileOutlined />,   SafetyOutlined: <SafetyOutlined />,
  StarOutlined: <StarOutlined />,
  BulbOutlined: <BulbOutlined />,
};

const Hero = () => {
  const destinations = [
    { city: 'Makkah', country: 'Arabie Saoudite', icon: <SafetyCertificateOutlined />, color: '#d4af37' },
    { city: 'Medina', country: 'Arabie Saoudite', icon: <StarOutlined />, color: '#00b894' },
    { city: 'Istanbul', country: 'Turquie', icon: <BankOutlined />, color: '#e74c3c' },
    { city: 'Paris', country: 'France', icon: <HeartOutlined />, color: '#3498db' },
    { city: 'Dubaï', country: 'EAU', icon: <CrownOutlined />, color: '#f39c12' },
  ];

  return (
    <>
      <div className="hero-section" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        paddingTop: '118px',
      }}>
        <img
          src="/img/hero-plane.jpg"
          alt="Avion dans le ciel"
          className="hero-bg-image"
        />
        <div className="hero-overlay" />

        <div className="hero-cloud hero-cloud-1" aria-hidden="true" />
        <div className="hero-cloud hero-cloud-2" aria-hidden="true" />

        <div style={{
          position: 'relative', zIndex: 1, width: '100%',
          maxWidth: '1200px', margin: '0 auto', padding: '0 24px',
        }}>
          <Row gutter={[40, 40]} align="middle">
            <Col xs={24} lg={13} className="hero-content">
              <Title level={1} className="hero-title" style={{
                color: '#fff', fontSize: 'clamp(1.5rem, 4.5vw, 3.2rem)',
                lineHeight: 1.15, marginBottom: '20px', fontWeight: 800,
                fontFamily: "'Montserrat', sans-serif",
                letterSpacing: '-0.02em',
                animation: 'fadeInUp 0.8s ease-out 0.15s both',
              }}>
                Explorez le Monde
                <br />
                avec{' '}
                <span style={{
                  background: 'linear-gradient(90deg, #d4af37, #f0d78c)',
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                }}>
                  Ndiouroul Voyages
                </span>
              </Title>

              <Paragraph style={{
                color: 'rgba(255,255,255,0.5)', fontSize: '1rem',
                lineHeight: 1.8, marginBottom: '32px', maxWidth: '460px',
                animation: 'fadeInUp 0.8s ease-out 0.3s both',
              }}>
                Vols, hotels, pelerinages, excursions et plus encore. Votre agence de voyage
                au Senegal pour des experiences inoubliables partout dans le monde.
              </Paragraph>

              <div className="hero-btns-wrap" style={{
                display: 'flex', gap: '12px', flexWrap: 'wrap',
                animation: 'fadeInUp 0.8s ease-out 0.45s both',
              }}>
                <Link to="/hadj-oumra" className="hero-btn-link">
                  <Button type="primary" size="large" icon={<SafetyCertificateOutlined />}
                    className="hero-btn-primary"
                  >
                    Hajj & Oumra
                  </Button>
                </Link>
                <Link to="/demander-devis" className="hero-btn-link">
                  <Button size="large" icon={<FileTextOutlined />}
                    className="hero-btn-outline"
                  >
                    Demander un devis
                  </Button>
                </Link>
              </div>
            </Col>

            <Col xs={24} lg={11} className="hero-visual-col" style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="hero-visual-wrap" style={{
                position: 'relative', width: 'clamp(280px, 30vw, 380px)',
                animation: 'fadeInUp 1s ease-out 0.3s both',
              }}>
                <div className="hero-ticket-card" style={{
                  position: 'relative', borderRadius: '20px', padding: '28px',
                  background: 'rgba(8,20,40,0.55)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  backdropFilter: 'blur(12px)',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
                }}>
                  <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                    background: 'rgba(212,175,55,0.12)', border: '1px solid rgba(212,175,55,0.25)',
                    borderRadius: '20px', padding: '4px 12px', marginBottom: '16px',
                  }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#d4af37' }} />
                    <Text style={{ color: '#d4af37', fontSize: '11px', fontWeight: 500, letterSpacing: '0.5px' }}>
                      Prochain Depart
                    </Text>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                    <div>
                      <Text style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', display: 'block', letterSpacing: '1px' }}>
                        DEPART
                      </Text>
                      <Text style={{ color: '#fff', fontSize: '20px', fontWeight: 700, fontFamily: "'Montserrat', sans-serif" }}>
                        Dakar
                      </Text>
                      <Text style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', display: 'block' }}>DSS</Text>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <div style={{ flex: 1, height: '1px', width: '42px', background: 'repeating-linear-gradient(90deg, rgba(255,255,255,0.35) 0 4px, transparent 4px 8px)' }} />
                      <div style={{
                        width: '34px', height: '34px', borderRadius: '50%',
                        background: 'rgba(212,175,55,0.12)', border: '1px solid rgba(212,175,55,0.3)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#d4af37', fontSize: '16px',
                      }}>
                        <RocketOutlined />
                      </div>
                      <div style={{ flex: 1, height: '1px', width: '42px', background: 'repeating-linear-gradient(90deg, rgba(255,255,255,0.35) 0 4px, transparent 4px 8px)' }} />
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <Text style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', display: 'block', letterSpacing: '1px' }}>
                        ARRIVEE
                      </Text>
                      <Text style={{ color: '#fff', fontSize: '20px', fontWeight: 700, fontFamily: "'Montserrat', sans-serif" }}>
                        La Mecque
                      </Text>
                      <Text style={{ color: 'rgba(255,255,255,0.4)', fontSize: '11px', display: 'block' }}>JED</Text>
                    </div>
                  </div>

                  <div style={{
                    borderTop: '1px dashed rgba(255,255,255,0.15)', margin: '16px 0',
                  }} />

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <Text style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', display: 'block' }}>Destination</Text>
                      <Text style={{ color: '#fff', fontSize: '14px', fontWeight: 600, display: 'block' }}>
                        <EnvironmentOutlined style={{ color: '#00b894', marginRight: '6px' }} />
                        Makkah, Arabie Saoudite
                      </Text>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <Text style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', display: 'block' }}>Prochaine date</Text>
                      <Text style={{ color: '#d4af37', fontSize: '14px', fontWeight: 600, display: 'block' }}>
                        Hajj 2026
                      </Text>
                    </div>
                  </div>
                </div>

                {destinations.map((dest, i) => (
                  <div key={i} className={`hero-dest-chip hero-dest-chip-${i}`} style={{
                    position: 'absolute',
                    display: 'flex', alignItems: 'center', gap: '7px',
                    background: 'rgba(8,20,40,0.7)',
                    border: `1px solid ${dest.color}30`,
                    borderRadius: '12px',
                    padding: '7px 11px',
                    whiteSpace: 'nowrap',
                    boxShadow: `0 6px 24px rgba(0,0,0,0.3)`,
                    backdropFilter: 'blur(8px)',
                    animation: `destFloat 4.5s ease-in-out ${i * 0.55}s infinite`,
                  }}>
                    <div style={{
                      width: '26px', height: '26px', borderRadius: '7px',
                      background: `${dest.color}18`,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: dest.color, fontSize: '12px',
                    }}>
                      {dest.icon}
                    </div>
                    <div>
                      <Text style={{
                        color: '#fff', fontSize: '11px', fontWeight: 600, display: 'block', lineHeight: 1.2,
                      }}>
                        {dest.city}
                      </Text>
                      <Text style={{
                        color: 'rgba(255,255,255,0.45)', fontSize: '9px', display: 'block', lineHeight: 1.2,
                      }}>
                        {dest.country}
                      </Text>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <style>{`
        .hero-section { background: #0a1628; }
        .hero-bg-image {
          position: absolute; inset: 0; width: 100%; height: 100%;
          object-fit: cover; object-position: center;
          animation: heroZoom 18s ease-in-out infinite alternate;
        }
        @keyframes heroZoom {
          0% { transform: scale(1); }
          100% { transform: scale(1.06); }
        }
        .hero-overlay {
          position: absolute; inset: 0; pointer-events: none;
          background: linear-gradient(90deg, rgba(6,18,38,0.92) 0%, rgba(6,18,38,0.6) 45%, rgba(6,18,38,0.15) 100%),
            linear-gradient(to bottom, rgba(6,18,38,0.15) 0%, transparent 40%, transparent 70%, rgba(6,18,38,0.55) 100%);
        }
        .hero-cloud {
          position: absolute; pointer-events: none; z-index: 1;
          background: radial-gradient(ellipse at center, rgba(255,255,255,0.14) 0%, transparent 65%);
          width: 320px; height: 120px; border-radius: 50%;
        }
        .hero-cloud-1 { top: 12%; right: -60px; animation: cloudDrift 26s linear infinite; }
        .hero-cloud-2 { top: 58%; right: -80px; animation: cloudDrift 32s linear infinite reverse; }
        @keyframes cloudDrift {
          0%   { transform: translateX(0) scale(1); opacity: 0.3; }
          50%  { transform: translateX(-260px) scale(1.15); opacity: 0.55; }
          100% { transform: translateX(0) scale(1); opacity: 0.3; }
        }
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(30px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes destFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .hero-dest-chip-0 { top: -6%; right: -6%; }
        .hero-dest-chip-1 { top: 18%; right: -14%; }
        .hero-dest-chip-2 { bottom: 24%; right: -16%; }
        .hero-dest-chip-3 { bottom: 2%; right: -4%; }
        .hero-dest-chip-4 { bottom: -8%; left: -6%; }
        .hero-section .ant-btn {
          animation: fadeInUp 0.8s ease-out 0.5s both;
        }
        .hero-section .ant-btn:last-child {
          animation: fadeInUp 0.8s ease-out 0.65s both;
        }
        @media (max-width: 991px) {
          .hero-visual-wrap { margin: 0 auto; }
          .hero-visual-col { display: none !important; }
        }
        @media (max-width: 768px) {
          .hero-section { padding-top: 0 !important; }
          .hero-overlay {
            background: linear-gradient(180deg, rgba(6,18,38,0.35) 0%, rgba(6,18,38,0.85) 100%);
          }
          .hero-content {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .hero-content .ant-paragraph {
            margin-left: auto;
            margin-right: auto;
          }
          .hero-dest-chip-0, .hero-dest-chip-1, .hero-dest-chip-2,
          .hero-dest-chip-3, .hero-dest-chip-4 { display: none; }
          .hero-ticket-card { padding: 22px !important; }
        }
        @media (max-width: 576px) {
          .hero-content .ant-paragraph { max-width: 320px; font-size: 0.92rem; line-height: 1.7; margin-left: auto; margin-right: auto; }
          .hero-btns-wrap { flex-direction: column; align-items: center; width: 100%; }
          .hero-btn-link { width: 100%; max-width: 280px; }
          .hero-btns-wrap .ant-btn { width: 100% !important; height: 46px !important; padding: 0 22px !important; font-size: 14px !important; }
          .hero-cloud { display: none; }
        }
      `}</style>
    </>
  );
};

const WhyUs = () => {
  const items = [
    { icon: <SafetyCertificateOutlined />, title: 'Agence Agreee', desc: 'Licence officielle de pelerinage delivree par l\'Etat du Senegal. Voyagez en toute legitimite et serenite.', color: '#1e3a5f' },
    { icon: <HomeOutlined />, title: 'Hotels 5\u2605', desc: 'Hebergements de luxe a quelques pas des lieux saints : Masjid al-Haram et Masjid al-Nabawi.', color: '#d4af37' },
    { icon: <HeartOutlined />, title: 'Accompagnement Complet', desc: 'Accompagnement religieux, administratif et medical tout au long de votre sejour.', color: '#00b894' },
    { icon: <TeamOutlined />, title: '14 Collaborateurs', desc: 'Une equipe dediee de professionnels au service exclusif des pelerins.', color: '#e74c3c' },
  ];
  return (
    <div className="content-section" style={{ background: '#f8f9fa' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div className="section-title" style={{ textAlign: 'center', marginBottom: '50px' }}>
          <span className="eyebrow">L'agence de confiance</span>
          <Title level={2} style={{ fontSize: 'clamp(1.6rem, 3vw, 2.25rem)', marginBottom: '12px', color: '#1e3a5f' }}>
            Pourquoi Nous Choisir ?
          </Title>
          <Text style={{ color: '#8492a6', fontSize: '1.02rem', lineHeight: 1.7, maxWidth: '560px' }}>
            Ndiouroul Voyage — votre partenaire de confiance pour le Hajj, la Oumra et tous vos voyages
          </Text>
        </div>
        <Row gutter={[30, 30]}>
          {items.map((item, i) => (
            <Col xs={24} sm={12} lg={6} key={i}>
              <Card style={{
                textAlign: 'center', borderRadius: '16px', border: '1px solid #eef2f7',
                boxShadow: '0 4px 20px rgba(11,29,51,0.05)', height: '100%',
                transition: 'all 0.3s cubic-bezier(0.25,0.46,0.45,0.94)', cursor: 'default',
                position: 'relative', overflow: 'hidden',
              }} className="why-card" hoverable>
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
                  background: `linear-gradient(90deg, ${item.color}, transparent)`,
                  opacity: 0.6,
                }} />
                <div style={{
                  width: '72px', height: '72px', borderRadius: '18px',
                  background: `${item.color}10`, display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  margin: '0 auto 20px', fontSize: '28px', color: item.color,
                  transition: 'all 0.3s',
                }}>
                  {item.icon}
                </div>
                <Title level={4} style={{ fontSize: '17px', marginBottom: '10px' }}>
                  {item.title}
                </Title>
                <Text style={{ color: '#6c757d', fontSize: '14px', lineHeight: 1.7 }}>
                  {item.desc}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

const HadjOumraHighlight = () => {
  const stats = [
    { icon: <TeamOutlined />, value: '1000+', label: 'Pèlerins accompagnés' },
    { icon: <CrownOutlined />, value: '5\u2605', label: 'Hôtels premium' },
    { icon: <CustomerServiceOutlined />, value: '24/7', label: 'Assistance sur place' },
    { icon: <SafetyCertificateOutlined />, value: 'Agréé', label: 'Licence officielle' },
  ];

  const offers = [
    {
      title: 'Oumra Gamouwaat',
      price: '1 700 000',
      features: ['Hébergement 5\u2605', 'Demi-pension buffet', '5L Zamzam offerts', 'Guide spirituel'],
      tag: 'Oumra',
      color: '#00b894',
    },
    {
      title: 'Hadj Premium',
      price: '5 500 000',
      features: ['Vol Flynas A/R', 'Hôtel 5\u2605 Movenpick', 'Pension complète', 'Accompagnement 360\u00b0'],
      tag: 'Hadj',
      popular: true,
      color: '#d4af37',
    },
  ];

  const features = [
    'Guide expert des rites du pèlerinage',
    'Hôtels 5\u2605 à quelques pas d\'al-Haram',
    'Accompagnement religieux & spirituel',
    'Suivi médical sur place',
    'Formalités administratives prises en charge',
    'Partenaires : Flynas, Turkish Airlines, Emirates',
  ];

  return (
    <div className="hadj-section" style={{ padding: 'clamp(60px, 9vw, 110px) 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', position: 'relative', zIndex: 1 }}>

        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <span className="eyebrow hadj-eyebrow">Pèlerinage Sacré</span>
          <Title level={2} style={{
            color: '#fff', fontSize: 'clamp(1.8rem, 4vw, 2.6rem)',
            marginBottom: '16px', fontWeight: 800, letterSpacing: '-0.02em',
          }}>
            Hadj & Oumra
          </Title>
          <Text style={{
            color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem',
            maxWidth: '600px', display: 'block', margin: '0 auto', lineHeight: 1.8,
          }}>
            Un accompagnement complet pensé dans les moindres détails pour un pèlerinage en toute sérénité.
          </Text>
        </div>

        <Row gutter={[{ xs: 24, lg: 56 }, { xs: 24, md: 40 }]} align="middle">
          <Col xs={24} lg={12}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '8px',
              background: 'rgba(212,175,55,0.1)', border: '1px solid rgba(212,175,55,0.3)',
              padding: '7px 16px', borderRadius: '24px', marginBottom: '22px',
            }}>
              <SafetyCertificateOutlined style={{ color: '#d4af37', fontSize: '14px' }} />
              <Text style={{ color: '#d4af37', fontSize: '12px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase' }}>
                Notre engagement
              </Text>
            </div>

            <Title level={3} style={{
              color: '#fff', fontSize: 'clamp(1.35rem, 2.6vw, 1.8rem)',
              marginBottom: '16px', lineHeight: 1.35,
            }}>
              Un accompagnement spirituel{' '}
              <span style={{ color: '#d4af37' }}>d'exception</span>
            </Title>

            <Paragraph style={{
              color: 'rgba(255,255,255,0.65)', fontSize: '1rem', lineHeight: 1.85,
              marginBottom: '30px', maxWidth: '480px',
            }}>
              De la préparation des formalités jusqu'à votre retour, notre équipe veille à ce que chaque
              étape se déroule en toute sérénité.
            </Paragraph>

            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px 20px',
              marginBottom: '36px',
            }}>
              {features.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                  <span style={{
                    width: '24px', height: '24px', borderRadius: '8px', flexShrink: 0,
                    background: 'rgba(0,184,148,0.12)', border: '1px solid rgba(0,184,148,0.3)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1px',
                  }}>
                    <CheckCircleOutlined style={{ color: '#00b894', fontSize: '11px' }} />
                  </span>
                  <Text style={{ color: 'rgba(255,255,255,0.85)', fontSize: '13.5px', lineHeight: 1.5 }}>
                    {item}
                  </Text>
                </div>
              ))}
            </div>

            <Space wrap className="hadj-btns-wrap" size="middle">
              <Button type="primary" size="large" icon={<ArrowRightOutlined />}
                className="hadj-btn-primary">
                <Link to="/hadj-oumra" style={{ color: 'var(--primary-ink)', fontWeight: 700 }}>
                  Découvrir nos offres
                </Link>
              </Button>
              <Button size="large" icon={<PhoneOutlined />}
                className="hadj-btn-outline">
                <Link to="/contact" style={{ color: '#fff' }}>Parler à un conseiller</Link>
              </Button>
            </Space>
          </Col>

          <Col xs={24} lg={12}>
            <div className="hadj-gold-border" style={{
              borderRadius: '22px', padding: '28px', position: 'relative',
              background: 'rgba(255,255,255,0.03)',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <Title level={3} style={{ color: '#d4af37', margin: 0, fontSize: '20px' }}>
                  Offres du Moment
                </Title>
                <span style={{
                  display: 'inline-flex', alignItems: 'center', gap: '6px',
                  background: 'rgba(0,184,148,0.12)', border: '1px solid rgba(0,184,148,0.3)',
                  padding: '4px 12px', borderRadius: '20px',
                }}>
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#00b894', animation: 'pulse-dot 2s infinite' }} />
                  <Text style={{ color: '#00b894', fontSize: '11px', fontWeight: 600 }}>En direct</Text>
                </span>
              </div>

              {offers.map((pack, i) => (
                <div key={i} style={{
                  position: 'relative',
                  background: pack.popular
                    ? 'linear-gradient(135deg, rgba(212,175,55,0.14), rgba(212,175,55,0.04))'
                    : 'rgba(255,255,255,0.04)',
                  borderRadius: '16px', padding: '22px', marginBottom: i < offers.length - 1 ? '16px' : 0,
                  border: pack.popular ? '1.5px solid rgba(212,175,55,0.4)' : '1px solid rgba(255,255,255,0.08)',
                  transition: 'all 0.3s',
                }}>
                  {pack.popular && (
                    <div style={{
                      position: 'absolute', top: '14px', right: '-8px',
                      background: 'linear-gradient(135deg, #e3c35a, #d4af37)',
                      color: 'var(--primary-ink)', fontSize: '10px', fontWeight: 700,
                      padding: '4px 14px 4px 10px', borderRadius: '8px 0 0 8px',
                      letterSpacing: '0.8px', textTransform: 'uppercase',
                    }}>
                      Populaire
                    </div>
                  )}

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', paddingRight: pack.popular ? '60px' : 0 }}>
                    <Text style={{ color: '#fff', fontWeight: 700, fontSize: '16px' }}>{pack.title}</Text>
                    <Tag color={pack.popular ? 'gold' : 'cyan'} style={{ margin: 0, fontWeight: 600, borderRadius: '6px' }}>
                      {pack.tag}
                    </Tag>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '14px' }}>
                    <Text style={{
                      color: '#d4af37', fontSize: '28px', fontWeight: 800,
                      fontFamily: "'Montserrat', sans-serif", letterSpacing: '-0.02em',
                    }}>
                      {pack.price}
                    </Text>
                    <Text style={{ color: 'rgba(255,255,255,0.45)', fontSize: '13px', fontWeight: 600 }}>FCFA</Text>
                  </div>

                  <div style={{
                    display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '18px',
                  }}>
                    {pack.features.map((f, j) => (
                      <span key={j} style={{
                        display: 'inline-flex', alignItems: 'center', gap: '5px',
                        background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.08)',
                        color: 'rgba(255,255,255,0.75)', fontSize: '12px', borderRadius: '8px',
                        padding: '5px 11px',
                      }}>
                        <CheckCircleOutlined style={{ color: pack.color, fontSize: '11px' }} />
                        {f}
                      </span>
                    ))}
                  </div>

                  <Button block size="middle" style={{
                    height: '42px', borderRadius: '12px', fontWeight: 700, fontSize: '13px',
                    background: pack.popular
                      ? 'linear-gradient(135deg, #e3c35a, #d4af37)'
                      : 'rgba(255,255,255,0.08)',
                    border: pack.popular ? 'none' : '1px solid rgba(255,255,255,0.15)',
                    color: pack.popular ? 'var(--primary-ink)' : '#fff',
                  }}>
                    <Link to="/demander-devis" style={{ color: 'inherit', fontWeight: 700 }}>
                      Réserver ce pack
                    </Link>
                  </Button>
                </div>
              ))}

              <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Link to="/hadj-oumra" style={{
                  color: '#d4af37', fontWeight: 600, fontSize: '14px',
                  display: 'inline-flex', alignItems: 'center', gap: '8px',
                  transition: 'all 0.2s',
                }}>
                  Voir toutes les offres <ArrowRightOutlined />
                </Link>
              </div>
            </div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} style={{ marginTop: '56px' }}>
          {stats.map((s, i) => (
            <Col xs={12} lg={6} key={i}>
              <div style={{
                display: 'flex', alignItems: 'center', gap: '14px',
                background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '16px', padding: '18px 20px', height: '100%',
                backdropFilter: 'blur(6px)', transition: 'all 0.3s',
              }}>
                <div style={{
                  width: '48px', height: '48px', borderRadius: '13px', flexShrink: 0,
                  background: 'linear-gradient(135deg, rgba(212,175,55,0.18), rgba(212,175,55,0.06))',
                  border: '1px solid rgba(212,175,55,0.25)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#d4af37', fontSize: '20px',
                }}>
                  {s.icon}
                </div>
                <div>
                  <Text style={{
                    color: '#fff', fontSize: '19px', fontWeight: 800, display: 'block',
                    fontFamily: "'Montserrat', sans-serif", lineHeight: 1.2,
                  }}>
                    {s.value}
                  </Text>
                  <Text style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', lineHeight: 1.4, display: 'block' }}>
                    {s.label}
                  </Text>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

const partners = [
  { name: 'Flynas', color: '#4a90d9', logo: '/img/partners/flynas.png', darkBg: true },
  { name: 'Turkish Airlines', color: '#c8102e', logo: '/img/partners/turkish-airlines.png' },
  { name: 'Emirates', color: '#d71921', logo: '/img/partners/emirates.svg' },
  { name: 'Movenpick', color: '#8b6914', logo: '/img/partners/movenpick.png' },
  { name: 'SGBS', color: '#00529b', logo: '/img/partners/sgbs.png' },
  { name: 'BIS', color: '#00875a', logo: '/img/partners/bis.png' },
];

const PartnerLogo = ({ name, color, logo, darkBg }) => (
  <div className="partner-logo-box" style={{
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: darkBg ? '#1a1a2e' : 'rgba(255,255,255,0.9)', borderRadius: '12px',
    padding: '16px 32px', minWidth: '180px', height: '80px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    border: darkBg ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.06)',
    transition: 'all 0.3s',
    flexShrink: 0,
  }}>
    {logo ? (
      <img
        src={logo}
        alt={name}
        style={{ maxHeight: '40px', maxWidth: '140px', objectFit: 'contain', filter: darkBg ? 'none' : 'grayscale(20%)' }}
      />
    ) : (
      <Text style={{
        fontSize: '16px', fontWeight: 700, color: color,
        fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.5px',
      }}>
        {name}
      </Text>
    )}
  </div>
);

const PartnersSection = () => (
  <div style={{ padding: '60px 0', background: '#f8f9fa' }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
      <div className="section-title" style={{ textAlign: 'center', marginBottom: '40px' }}>
        <span className="eyebrow">Ils nous accompagnent</span>
        <Title level={2} style={{ fontSize: 'clamp(1.6rem, 3vw, 2rem)', marginBottom: '12px', color: '#1e3a5f' }}>
          Nos Partenaires
        </Title>
        <Text style={{ color: '#8492a6', fontSize: '1rem' }}>
          Compagnies aériennes, hôtels et banques de confiance
        </Text>
      </div>
    </div>
    <div style={{ overflow: 'hidden', position: 'relative', width: '100%' }}>
      <div className="partners-fade-left" />
      <div className="partners-fade-right" />
      <Swiper
        modules={[Autoplay, FreeMode]}
        autoplay={{ delay: 0, disableOnInteraction: false, reverseDirection: false }}
        freeMode={{ enabled: true, momentum: false }}
        speed={3000}
        loop={true}
        slidesPerView="auto"
        spaceBetween={24}
        style={{ width: '100%', padding: '10px 0' }}
      >
        {[...partners, ...partners, ...partners].map((p, i) => (
          <SwiperSlide key={i} style={{ width: 'auto' }}>
            <PartnerLogo name={p.name} color={p.color} logo={p.logo} darkBg={p.darkBg} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </div>
);

const allServices = [
  { title: 'Hadj & Oumra', slug: 'hadj-oumra', shortDescription: 'Service phare tout compris', icon: 'BankOutlined', link: '/hadj-oumra' },
  { title: 'Location de vehicules', slug: 'location-vehicules', shortDescription: 'Voitures et minibus', icon: 'CarOutlined', link: '/services/location-vehicules' },
  { title: 'Navette AIBD', slug: 'navette-aibd', shortDescription: 'Navettes aeroportuaires 24h/24', icon: 'EnvironmentOutlined', link: '/services/navette-aibd' },
  { title: 'Assurance', slug: 'assurance', shortDescription: 'Auto et voyage', icon: 'SafetyOutlined', link: '/services/assurance' },
  { title: 'Conseils', slug: 'conseils', shortDescription: 'Accompagnement experts', icon: 'BulbOutlined', link: '/services/conseils' },
];

const ServicesPreview = ({ services }) => {
  const merged = [...allServices];
  services.forEach(s => {
    if (!merged.find(m => m.slug === s.slug)) {
      merged.push({ ...s, link: `/services/${s.slug}` });
    }
  });

  return (
    <div className="content-section">
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div className="section-title" style={{ textAlign: 'center', marginBottom: '50px' }}>
          <span className="eyebrow">Ce que nous proposons</span>
          <Title level={2} style={{ fontSize: 'clamp(1.6rem, 3vw, 2.25rem)', marginBottom: '12px', color: '#1e3a5f' }}>
            Nos Services
          </Title>
          <Text style={{ color: '#8492a6', fontSize: '1.02rem' }}>
            Des solutions complètes pour tous vos besoins de voyage
          </Text>
        </div>
        <Row gutter={[24, 24]} justify="center">
          {merged.map((service, i) => (
            <Col xs={24} sm={12} lg={8} key={i}>
              <Link to={service.link}>
                <Card className="service-card" hoverable style={{ height: '100%' }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{
                      width: '60px', height: '60px', borderRadius: '14px',
                      background: 'linear-gradient(135deg, #1e3a5f10, #00b89410)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      margin: '0 auto 15px', fontSize: '26px', color: '#1e3a5f',
                    }}>
                      {iconMap[service.icon] || <AppstoreOutlined />}
                    </div>
                    <Title level={5} style={{ fontSize: '15px', marginBottom: '8px' }}>
                      {service.title}
                    </Title>
                    <Text style={{ color: '#6c757d', fontSize: '13px' }}>
                      {service.shortDescription}
                    </Text>
                    <div style={{ marginTop: '15px' }}>
                      <ArrowRightOutlined style={{ color: '#00b894', fontSize: '14px' }} />
                    </div>
                  </div>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

const Testimonials = () => {
  const testimonials = [
    { name: 'Fatou Diop', role: 'Pelerine Oumra 2024', text: 'Un service exceptionnel du debut a la fin. L\'accompagnement pour mon Oumra etait parfait. Merci Ndiouroul Voyages !', rating: 5 },
    { name: 'Mamadou Sall', role: 'Voyageur regulier', text: 'Je fais confiance a Ndiouroul Voyages pour tous mes deplacements professionnels. Fiable, ponctuel et toujours a l\'ecoute.', rating: 5 },
    { name: 'Aissatou Ndiaye', role: 'Hadj 2024', text: 'Le pack Premium pour le Hadj valait chaque franc. Hotel superbien situe, guide excellent. Une experience inoubliable.', rating: 5 },
  ];
  return (
    <div className="content-section" style={{ background: '#f8f9fa' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <div className="section-title" style={{ textAlign: 'center', marginBottom: '50px' }}>
          <span className="eyebrow">Témoignages</span>
          <Title level={2} style={{ fontSize: 'clamp(1.6rem, 3vw, 2.25rem)', marginBottom: '12px', color: '#1e3a5f' }}>
            Avis de Nos Clients
          </Title>
          <Text style={{ color: '#8492a6', fontSize: '1.02rem' }}>
            Ce que disent ceux qui nous ont fait confiance
          </Text>
        </div>
        <Row gutter={[30, 30]}>
          {testimonials.map((t, i) => (
            <Col xs={24} md={8} key={i}>
              <Card style={{
                borderRadius: '16px', border: '1px solid #eef2f7',
                boxShadow: '0 4px 20px rgba(11,29,51,0.05)', height: '100%',
                position: 'relative', transition: 'all 0.3s',
              }}>
                <div style={{
                  position: 'absolute', top: '-14px', left: '22px',
                  width: '40px', height: '40px', borderRadius: '12px',
                  background: 'linear-gradient(135deg, #e3c35a, #d4af37)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: '20px', fontFamily: 'Georgia, serif',
                  boxShadow: '0 6px 16px rgba(212,175,55,0.35)',
                }}>&ldquo;</div>
                <Rate disabled defaultValue={t.rating} style={{ color: '#d4af37', fontSize: '14px', marginBottom: '15px' }} />
                <Paragraph style={{ color: '#4a5a72', fontSize: '14px', lineHeight: 1.8, marginBottom: '20px', fontStyle: 'italic' }}>
                  {t.text}
                </Paragraph>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', borderTop: '1px solid #eef2f7', paddingTop: '16px' }}>
                  <div style={{
                    width: '45px', height: '45px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, #1e3a5f, #2a5298)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: '700', fontSize: '16px',
                  }}>
                    {t.name.charAt(0)}
                  </div>
                  <div>
                    <Text style={{ fontWeight: '600', display: 'block', fontSize: '14px' }}>{t.name}</Text>
                    <Text style={{ color: '#8492a6', fontSize: '12px' }}>{t.role}</Text>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

const CTASection = () => (
  <div className="cta-section">
    <div style={{ maxWidth: '700px', margin: '0 auto', padding: '0 20px' }}>
      <Title level={2} style={{ color: '#fff', marginBottom: '15px' }}>
        Pret a Voyager ?
      </Title>
      <Paragraph style={{ color: 'rgba(255,255,255,0.85)', fontSize: '1.1rem', marginBottom: '30px' }}>
        Obtenez un devis gratuit et personnalise pour votre prochain voyage. Notre equipe est prete a realiser votre reve.
      </Paragraph>
      <Space size="middle" wrap className="cta-btns-wrap">
        <Button size="large" icon={<FileTextOutlined />} className="cta-btn-devis">
          <Link to="/demander-devis" style={{ color: '#00b894' }}>Demander un devis</Link>
        </Button>
        <Button size="large" icon={<WhatsAppOutlined />} className="cta-btn-whatsapp">
          <a href="https://wa.me/221787362727" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>
            WhatsApp
          </a>
        </Button>
      </Space>
    </div>
  </div>
);

const Home = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get('/services/highlighted').then(res => setServices(res.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Hero />
      <WhyUs />
      <HadjOumraHighlight />
      <ServicesPreview services={services} />
      <PartnersSection />
      <Testimonials />
      <CTASection />
    </div>
  );
};

export default Home;